module.exports = __webpack_public_path__ + "img/@ico_recruit.5e124222.png";